import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const BallWrap = styled(motion.div)`
  max-height: 150px;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  overflow-y: auto;
  overflow-x: hidden;
`

const Number = styled(motion.span)`
  position: relative;
  min-width: 120px;
  min-height: 120px;
  margin: 10px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  border-radius: 50%;
  color: #5f5f5f;
  box-shadow: inset 3px 3px 9px #e2e2e2, inset 3px 3px 9px #f1f1f1;
  background: #fff;
  user-select: none;

  > sup {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    color: #000;
  }

  &:first-child {
    box-shadow: none;
    background: var(--main-color);
    color: #fff;
    font-weight: bold;
  }
`

function BallNumber({ result }) {
  return (
    <BallWrap>
      {result.length
        ? result.map((num, key) => (
            <Number
              initial={{ x: -150, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              key={key}
            >
              <sup>{result.length - key}</sup>
              {num}
            </Number>
          ))
        : ''}
    </BallWrap>
  )
}

export default React.memo(BallNumber)
